import React from "react";
import { useSearchParams } from "react-router-dom";
import ViewPickupMail from "pages/Report/ViewPickupMail";

const ViewMailPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const pickup_code = searchParams.get("pickup_code");

  return (
    <div className="p-4">
      <ViewPickupMail pickup_code={pickup_code || ""} />
    </div>
  );
};

export default ViewMailPage;
